export enum TCreatorTypeOptionsEnum {
    SELF = 'self',
    GROUP = 'group',
}

export enum TPostPrivacyOptionsEnum {
    USERS = 'users',
    FRIENDS = 'friends',
    ME = 'me',
}

export enum TPostCategoryEnum {
    USER = 'user',
    PHOTO = 'photo',
    GROUP = 'group',
    TRIP = 'trip',
    ALL = 'all',
}
